<div class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <!-- Organization TreeSelect (server-side filtering — see onOrganizationTreeShow in .ts) -->
      <div class="col-lg-3 col-md-4 organization-col">
        <div class="d-flex flex-column">
          <label class="form-label small fw-semibold">Organization</label>
          <p-treeSelect
            #orgTreeSelect
            class="w-100"
            [(ngModel)]="selectedOrganizationsModel"
            [options]="organizationTreeData()"
            display="chip"
            [metaKeySelection]="false"
            selectionMode="checkbox"
            placeholder="Search organizations"
            [filter]="true"
            [loading]="isLoadingOrganizations()"
            [virtualScroll]="true"
            [virtualScrollItemSize]="32"
            panelStyleClass="audit-org-panel"
            [propagateSelectionDown]="true"
            [propagateSelectionUp]="false"
            [appendTo]="'body'"
            (onShow)="onOrganizationTreeShow()"
            (onHide)="onOrganizationTreeHide()"
          >
            <ng-template pTemplate="value">
              @if (getSelectedOrganizationCount() > 0) {
                <div class="d-flex flex-wrap gap-1 align-items-center">
                  @for (node of getVisibleSelectedNodes(); track node.key) {
                    <span class="p-treeselect-chip">
                      {{ node.label }}
                      <span
                        class="p-treeselect-chip-icon pi pi-times"
                        (click)="removeNode($event, node)"
                      ></span>
                    </span>
                  }
                  @if (getSelectedOrganizationCount() > 1) {
                    <span class="p-treeselect-chip summary-chip">+{{ getSelectedOrganizationCount() - 1 }} more</span>
                  }
                </div>
              } @else {
                <span class="p-placeholder">Select organizations</span>
              }
            </ng-template>
            <ng-template let-node pTemplate="default">
              <span class="org-node-label" [attr.title]="node.label">{{ node.label }}</span>
            </ng-template>
          </p-treeSelect>
        </div>
      </div>

      <!-- Outcome Dropdown -->
      <div class="col-lg-2 col-md-4">
        <div class="d-flex flex-column">
          <label class="form-label small fw-semibold">Outcome</label>
          <kendo-dropdownlist
            [data]="outcomes()"
            [(ngModel)]="selectedOutcome"
            [textField]="'label'"
            [valueField]="'value'"
            [defaultItem]="{ label: 'All', value: '' }"
            [valuePrimitive]="true"
            class="w-100"
          ></kendo-dropdownlist>
        </div>
      </div>

      <!-- Action Dropdown -->
      <div class="col-lg-2 col-md-4">
        <div class="d-flex flex-column">
          <label class="form-label small fw-semibold">Action</label>
          <kendo-dropdownlist
          [data]="actions()"
          [(ngModel)]="selectedAction"
          [textField]="'label'"
          [valueField]="'value'"
          [defaultItem]="{ label: 'All', value: '' }"
          [valuePrimitive]="true"
          class="w-100"
        ></kendo-dropdownlist>
        </div>
      </div>

      <!-- Event Type Dropdown -->
      <div class="col-lg-2 col-md-4">
        <div class="d-flex flex-column">
          <label class="form-label small fw-semibold">Event Type</label>
          <kendo-dropdownlist
            [data]="eventTypes()"
            [(ngModel)]="selectedEventType"
            [textField]="'label'"
            [valueField]="'value'"
            [defaultItem]="{ label: 'All', value: '' }"
            [valuePrimitive]="true"
            class="w-100"
          ></kendo-dropdownlist>
        </div>
      </div>

      <!-- User Type Dropdown -->
      <div class="col-lg-2 col-md-4">
        <div class="d-flex flex-column">
          <label class="form-label small fw-semibold">User Type</label>
          <kendo-dropdownlist
          [data]="userTypes()"
          [(ngModel)]="selectedUserType"
          [textField]="'label'"
          [valueField]="'value'"
          [defaultItem]="{ label: 'All', value: '' }"
          [valuePrimitive]="true"
          class="w-100"
        ></kendo-dropdownlist>
        </div>
      </div>

      <!-- Date Range -->
      <div class="col-lg-3 col-md-6">
        <div class="d-flex flex-column">
          <label class="form-label small fw-semibold">Date Range</label>
          <div class="d-flex gap-2 align-items-center">
            <kendo-datepicker
              [(ngModel)]="startDate"
              [placeholder]="'Start'"
              class="flex-grow-1"
            ></kendo-datepicker>
            <span class="text-muted">to</span>
            <kendo-datepicker
              [(ngModel)]="endDate"
              [placeholder]="'End'"
              class="flex-grow-1"
            ></kendo-datepicker>
          </div>
        </div>
      </div>

      <!-- Filter Buttons -->
      <div class="col-lg-3 col-md-6">
        <div class="d-flex flex-column">
          <div class="d-flex gap-2">
          <button
            kendoButton
            class="cyflare-btn-primary"
            (click)="applyFilters()"
          >
            Apply Filters
          </button>
          <button
            kendoButton
            class="cyflare-btn-secondary"
            (click)="resetFilters()"
            [disabled]="!hasActiveFilters()"
          >
            Clear
          </button>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
